/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PortfolioCacheRefreshStatus } from './PortfolioCacheRefreshStatus';
import {
    PortfolioCacheRefreshStatusFromJSON,
    PortfolioCacheRefreshStatusFromJSONTyped,
    PortfolioCacheRefreshStatusToJSON,
} from './PortfolioCacheRefreshStatus';

/**
 * 
 * @export
 * @interface PortfolioCacheRefreshEvidence
 */
export interface PortfolioCacheRefreshEvidence {
    /**
     * 
     * @type {PortfolioCacheRefreshStatus}
     * @memberof PortfolioCacheRefreshEvidence
     */
    status: PortfolioCacheRefreshStatus;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCacheRefreshEvidence
     */
    asOfDate: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioCacheRefreshEvidence
     */
    portfolioCount: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioCacheRefreshEvidence
     */
    positionCount: number;
}



/**
 * Check if a given object implements the PortfolioCacheRefreshEvidence interface.
 */
export function instanceOfPortfolioCacheRefreshEvidence(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "asOfDate" in value;
    isInstance = isInstance && "portfolioCount" in value;
    isInstance = isInstance && "positionCount" in value;

    return isInstance;
}

export function PortfolioCacheRefreshEvidenceFromJSON(json: any): PortfolioCacheRefreshEvidence {
    return PortfolioCacheRefreshEvidenceFromJSONTyped(json, false);
}

export function PortfolioCacheRefreshEvidenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioCacheRefreshEvidence {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': PortfolioCacheRefreshStatusFromJSON(json['status']),
        'asOfDate': json['as_of_date'],
        'portfolioCount': json['portfolio_count'],
        'positionCount': json['position_count'],
    };
}

export function PortfolioCacheRefreshEvidenceToJSON(value?: PortfolioCacheRefreshEvidence | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': PortfolioCacheRefreshStatusToJSON(value.status),
        'as_of_date': value.asOfDate,
        'portfolio_count': value.portfolioCount,
        'position_count': value.positionCount,
    };
}

